import useGlobalListener from './useGlobalListener';

const useKeyboardKey = (keyCode: number, callback: (...args: any[]) => any) => {
  const keyHandler = (e: KeyboardEvent) => {
    if (e.keyCode === keyCode) {
      callback();
    }
  };

  return useGlobalListener('keydown', keyHandler);
};

export default useKeyboardKey;
